import { useEffect, useState } from "react";
import axios from "axios";
import { DEFAULT_CATEGORY_ORDER } from "@/admin/categoryConfig";

const API = process.env.REACT_APP_BACKEND_URL;

// Fetched once per page load and shared across every consumer (Home page
// tile grid + Shop/Bushtech nav dropdowns) — avoids duplicate network calls
// and any visible re-order flash once the real order lands.
let cachedOrder = null;
let inflight = null;

export function useCategoryOrder() {
  const [order, setOrder] = useState(cachedOrder || DEFAULT_CATEGORY_ORDER);

  useEffect(() => {
    if (cachedOrder) return;
    if (!inflight) {
      inflight = axios
        .get(`${API}/api/site-settings`)
        .then((r) => r.data.categoryOrder || DEFAULT_CATEGORY_ORDER)
        .catch(() => DEFAULT_CATEGORY_ORDER);
    }
    inflight.then((data) => {
      cachedOrder = data;
      setOrder(data);
    });
  }, []);

  return order;
}

// Sorts `items` by the position of `getSlug(item)` inside `order`. Items
// whose slug isn't found (or that share a slug with an earlier item, e.g. the
// "12V Fridges" and "LED Lighting" tiles both map to "12v-fridges") keep
// their original relative order — a stable sort, so reordering one category
// moves its whole group together instead of splitting it apart.
export function sortBySlug(items, order, getSlug) {
  return items
    .map((item, i) => {
      const idx = order.indexOf(getSlug(item));
      return { item, i, key: idx === -1 ? order.length : idx };
    })
    .sort((a, b) => a.key - b.key || a.i - b.i)
    .map((x) => x.item);
}
